import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import doctorService from "./doctorService";
import {
  AddAvailabilityDTO,
  AddAvailabilityTimeSlotDTO,
  AddDoctorPermissionsDTO,
  AddFeeDTO,
  AddServiceDTO,
  AddUnAvailabilityDTO,
  DeleteAvailabilityDTO,
  DeleteServiceDTO,
  DeleteUnAvailabilityDTO,
  DoctorRegisterDTO,
  DoctorValidateDTO,
  GetAvailabilityDTO,
  GetDoctorFeeDTO,
  GetDoctorPermissionsDTO,
  GetPaymentAttachmentDTO,
  GetPaymentDTO,
  GetUnAvailabilityDTO,
  RegisterVerifyOTPDTO,
} from "../../dtos/doctor";

const initialState = {
  validateDoctorPayload: null,
  registerDoctorPayload: null,
  addAvailabiltyPayload: null,
  addUnAvailabiltyPayload: null,
  doctorAvailabilites: [],
  unavailabilities: [],
  addFeePayload: null,
  Payment: null,
  Payments: null,
  editEducationPayload: null,
  deleteAvailabilityPayload: null,
  addServicePayload: null,
  deleteServicePayload: null,
  getDoctorFeePayload: null,
  getDoctorPaymentPayload: null,
  verifyOTPPayload: null,
  getDoctorPermissionsPayload: null,
  addDoctorPermissionsPayload: null,
  ClinicAttachmentsPayload: null,
  DrAttachmentsPayload: [],

  isValidateDoctorError: false,
  isRegisterDoctorError: false,
  isAddAvailabiltyError: false,
  isDoctorAvailabiltyError: false,
  isDoctorUnAvailabiltyError: false,
  isAddFeeError: false,
  isgetPaymentError: false,
  isgetPdfError: false,
  isgetDrPdfError: false,
  isEditEducationError: false,
  isDeleteAvailabiltyError: false,
  isAddServiceError: false,
  isDeleteServiceError: false,
  isGetDoctorFeeError: false,
  isVerifyOTPError: false,
  isGetDoctorPermissionsError: false,
  isAddDoctorPermissionsError: false,

  isSuccess: false,
  isDoctorPaymentLoading: false,
  isGetAvailabilityAgainstAppointmentLoading: false,

  isLoading: false,
  isValidateDoctorLoading: false,
  isRegisterDoctorLoading: false,
  isAddAvailabiltyLoading: false,
  isAddUnAvailabiltyLoading: false,
  isDoctorAvailabiltyLoading: false,
  isDoctorUnAvailabiltyLoading: false,
  isAddFeeLoading: false,
  isEditEducationLoading: false,
  isDeleteAvailabiltyLoading: false,
  isDeleteDoctorUnavailabilityLoading: false,
  isAddServiceLoading: false,
  isDeleteServiceLoading: false,
  isGetDoctorFeeLoading: false,
  isGetDoctorPaymentLoading: false,
  isGetClinicPaymentLoading: false,
  isGetClinicPdfLoading: false,
  isGetDrPdfLoading: false,
  isVerifyOTPLoading: false,
  isGetDoctorPermissionsLoading: false,
  isAddDoctorPermissionsLoading: false,

  validateMessage: "",
  registerMessage: "",
  addAvailabiltyMessage: "",
  doctorAvailabiltyMessage: "",
  doctorUnAvailabiltyMessage: "",
  addFeeMessage: "",
  editEducationMessage: "",
  deleteAvailabiltyMessage: "",
  addServiceMessage: "",
  deleteServiceMessage: "",
  getDoctorFeeMessage: "",
  getDoctorPaymentMessage: "",
  getClinicPaymentMessage: "",
  getClinicPdfMessage: "",
  getDrPdfMessage: "",
  verifyOTPMessage: "",
  getDoctorPermissionsMessage: "",
  addDoctorPermissionsMessage: "",
  getPaymentMessage: "",
};

export const validateDoctor = createAsyncThunk(
  "doctor/validate",
  async (user: DoctorValidateDTO, thunkAPI) => {
    try {
      return await doctorService.validateDoctor(user);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const registerDoctor = createAsyncThunk(
  "admin/doctor/add",
  async (doctor: DoctorRegisterDTO, thunkAPI) => {
    try {
      return await doctorService.registerDoctor(doctor);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const registerVerifyOtp = createAsyncThunk(
  "doctor/verify-otp",
  async (doctor: RegisterVerifyOTPDTO, thunkAPI) => {
    try {
      return await doctorService.registerVerifyOtp(doctor);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addAvailability = createAsyncThunk(
  "admin/doctor/availability/add",
  async (doctor: AddAvailabilityDTO, thunkAPI) => {
    try {
      return await doctorService.addAvailability(doctor);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAvailability = createAsyncThunk(
  "admin/doctor/availability/get",
  async (doctor: GetAvailabilityDTO, thunkAPI) => {
    try {
      return await doctorService.getAvailability(doctor);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteAvailability = createAsyncThunk(
  "admin/doctor/availability/delete",
  async (dto: DeleteAvailabilityDTO, thunkAPI) => {
    try {
      return await doctorService.deleteAvailability(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addUnAvailability = createAsyncThunk(
  "admin/doctor/unavailability/add",
  async (doctor: AddUnAvailabilityDTO, thunkAPI) => {
    try {
      return await doctorService.addDocUnAvailability(doctor);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addAvailabilityTimeSlot = createAsyncThunk(
  "doctor/appointment/duration/set",
  async (doctor: AddAvailabilityTimeSlotDTO, thunkAPI) => {
    try {
      return await doctorService.addAvailabilityTimeSlot(doctor);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getUnAvailability = createAsyncThunk(
  "admin/doctor/unavailability/get",
  async (doctor: GetUnAvailabilityDTO, thunkAPI) => {
    try {
      return await doctorService.geDoctUnAvailability(doctor);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteUnAvailability = createAsyncThunk(
  "admin/doctor/unavailability/delete",
  async (dto: DeleteUnAvailabilityDTO, thunkAPI) => {
    try {
      return await doctorService.deleteDocUnAvailability(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addFee = createAsyncThunk(
  "admin/doctor/fee/add",
  async (dto: AddFeeDTO, thunkAPI) => {
    try {
      return await doctorService.addFee(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addService = createAsyncThunk(
  "services/add",
  async (dto: AddServiceDTO, thunkAPI) => {
    try {
      return await doctorService.addService(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteService = createAsyncThunk(
  "services/delete",
  async (dto: DeleteServiceDTO, thunkAPI) => {
    try {
      return await doctorService.deleteService(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getDoctorFee = createAsyncThunk(
  "doctor/fee/get",
  async (dto: GetDoctorFeeDTO, thunkAPI) => {
    try {
      return await doctorService.getDoctorFee(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getDoctorPayment = createAsyncThunk(
  "/api/admin/doctor/payments",
  async (dto: any, thunkAPI) => {
    try {
      return await doctorService.getDocPament(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getDrPaymentAttachments = createAsyncThunk(
  "/api/admin/doctor/payments/attachment/get",
  async (dto: GetPaymentAttachmentDTO, thunkAPI) => {
    try {
      return await doctorService.getdrPaymentAttachments(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getClinicPaymentAttachments = createAsyncThunk(
  "/api/admin/clinic/payments/attachment/get",
  async (dto: GetPaymentAttachmentDTO, thunkAPI) => {
    try {
      return await doctorService.getClicicPaymentAttachments(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getClinicPayment = createAsyncThunk(
  "/api/admin/clinic/payments",
  async (dto: any, thunkAPI) => {
    try {
      return await doctorService.getclinicPament(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getDoctorPermissions = createAsyncThunk(
  "doctor/doc-permissions/view",
  async (dto: GetDoctorPermissionsDTO, thunkAPI) => {
    try {
      return await doctorService.getDoctorPermissions(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addDoctorPermissions = createAsyncThunk(
  "doctor/doc-permissions/add",
  async (dto: AddDoctorPermissionsDTO, thunkAPI) => {
    try {
      return await doctorService.addDoctorPermissions(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const doctorAuthSlice = createSlice({
  name: "doctorSlice",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateDoctor.pending, (state) => {
        state.isValidateDoctorLoading = true;
      })
      .addCase(validateDoctor.fulfilled, (state, action) => {
        state.isValidateDoctorLoading = false;
        state.isSuccess = true;
        state.validateMessage = "";
        state.isValidateDoctorError = false;
        state.validateDoctorPayload = action.payload;
      })
      .addCase(validateDoctor.rejected, (state, action: PayloadAction<any>) => {
        state.isValidateDoctorLoading = false;
        state.isValidateDoctorError = true;
        state.validateMessage = action.payload;
      })
      .addCase(registerDoctor.pending, (state) => {
        state.isRegisterDoctorLoading = true;
      })
      .addCase(registerDoctor.fulfilled, (state, action) => {
        state.isRegisterDoctorLoading = false;
        state.isSuccess = true;
        state.registerMessage = "";
        state.registerDoctorPayload = action.payload;
      })
      .addCase(registerDoctor.rejected, (state, action: PayloadAction<any>) => {
        state.isRegisterDoctorLoading = false;
        state.isRegisterDoctorError = true;
        state.registerMessage = action.payload;
        state.registerDoctorPayload = null;
      })
      .addCase(addAvailability.pending, (state) => {
        state.isAddAvailabiltyLoading = true;
      })
      .addCase(addAvailability.fulfilled, (state, action) => {
        state.isAddAvailabiltyLoading = false;
        state.isSuccess = true;
        state.addAvailabiltyMessage = "";
        state.addAvailabiltyPayload = action.payload;
      })
      .addCase(
        addAvailability.rejected,
        (state, action: PayloadAction<any>) => {
          state.isAddAvailabiltyLoading = false;
          state.isAddAvailabiltyError = true;
          state.addAvailabiltyMessage = action.payload;
          state.addAvailabiltyPayload = null;
        }
      )
      .addCase(getAvailability.pending, (state) => {
        state.isDoctorAvailabiltyLoading = true;
      })
      .addCase(getAvailability.fulfilled, (state, action) => {
        state.isDoctorAvailabiltyLoading = false;
        state.isSuccess = true;
        state.doctorAvailabiltyMessage = "";
        state.doctorAvailabilites = action.payload;
      })
      .addCase(
        getAvailability.rejected,
        (state, action: PayloadAction<any>) => {
          state.isDoctorAvailabiltyLoading = false;
          state.isDoctorAvailabiltyError = true;
          state.doctorAvailabiltyMessage = action.payload;
          state.doctorAvailabilites = <any>[];
        }
      )

      .addCase(addUnAvailability.fulfilled, (state, action) => {
        state.isAddUnAvailabiltyLoading = false;
        state.isSuccess = true;
        state.addAvailabiltyMessage = "";
        state.addUnAvailabiltyPayload = action.payload;
      })
      .addCase(
        addUnAvailability.rejected,
        (state, action: PayloadAction<any>) => {
          state.isAddUnAvailabiltyLoading = false;
          state.isAddAvailabiltyError = true;
          state.addAvailabiltyMessage = action.payload;
          state.addUnAvailabiltyPayload = null;
        }
      )
      .addCase(getUnAvailability.pending, (state) => {
        state.isDoctorUnAvailabiltyLoading = true;
      })
      .addCase(getUnAvailability.fulfilled, (state, action) => {
        state.isDoctorUnAvailabiltyLoading = false;
        state.isSuccess = true;
        state.doctorUnAvailabiltyMessage = "";
        state.unavailabilities = action.payload;
      })
      .addCase(
        getUnAvailability.rejected,
        (state, action: PayloadAction<any>) => {
          state.isDoctorUnAvailabiltyLoading = false;
          state.isDoctorUnAvailabiltyError = true;
          state.doctorUnAvailabiltyMessage = action.payload;
          state.unavailabilities = [];
        }
      )

      .addCase(addFee.pending, (state) => {
        state.isAddFeeLoading = true;
      })
      .addCase(addFee.fulfilled, (state, action) => {
        state.isAddFeeLoading = false;
        state.isSuccess = true;
        state.addFeeMessage = "";
        state.addFeePayload = action.payload;
      })
      .addCase(addFee.rejected, (state, action: PayloadAction<any>) => {
        state.isAddFeeLoading = false;
        state.isAddFeeError = true;
        state.addFeeMessage = action.payload;
      })

      .addCase(getDoctorPayment.pending, (state) => {
        state.isGetDoctorPaymentLoading = true;
      })
      .addCase(getDoctorPayment.fulfilled, (state, action) => {
        state.isGetDoctorPaymentLoading = false;
        state.isSuccess = true;
        state.getDoctorPaymentMessage = "";
        state.Payment = action.payload;
      })
      .addCase(
        getDoctorPayment.rejected,
        (state, action: PayloadAction<any>) => {
          state.isGetDoctorPaymentLoading = false;
          state.isgetPaymentError = true;
          state.getDoctorPaymentMessage = action.payload;
        }
      )

      .addCase(getDrPaymentAttachments.pending, (state) => {
        state.isGetDoctorPaymentLoading = true;
      })
      .addCase(getDrPaymentAttachments.fulfilled, (state, action) => {
        state.isGetDoctorPaymentLoading = false;
        state.isSuccess = true;
        state.getDoctorPaymentMessage = "";
        state.DrAttachmentsPayload = action.payload;
      })
      .addCase(
        getDrPaymentAttachments.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isgetPaymentError = true;
          state.getDoctorPaymentMessage = action.payload;
        }
      )

      .addCase(getClinicPaymentAttachments.pending, (state) => {
        state.isGetDoctorPaymentLoading = true;
      })
      .addCase(getClinicPaymentAttachments.fulfilled, (state, action) => {
        state.isGetDoctorPaymentLoading = false;
        state.isSuccess = true;
        state.getDoctorPaymentMessage = "";
        state.ClinicAttachmentsPayload = action.payload;
      })
      .addCase(
        getClinicPaymentAttachments.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isgetPaymentError = true;
          state.getPaymentMessage = action.payload;
        }
      )

      .addCase(getClinicPayment.pending, (state) => {
        state.isGetClinicPaymentLoading = true;
      })
      .addCase(getClinicPayment.fulfilled, (state, action) => {
        state.isGetClinicPaymentLoading = false;
        state.isSuccess = true;
        state.getClinicPaymentMessage = "";
        state.Payments = action.payload;
      })
      .addCase(
        getClinicPayment.rejected,
        (state, action: PayloadAction<any>) => {
          state.isGetClinicPaymentLoading = false;
          state.isgetPaymentError = true;
          state.getClinicPaymentMessage = action.payload;
        }
      )

      .addCase(deleteAvailability.pending, (state) => {
        state.isDeleteAvailabiltyLoading = true;
      })
      .addCase(deleteAvailability.fulfilled, (state, action) => {
        state.isDeleteAvailabiltyLoading = false;
        state.isSuccess = true;
        state.deleteAvailabiltyMessage = "";
        state.deleteAvailabilityPayload = action.payload;
      })
      .addCase(
        deleteAvailability.rejected,
        (state, action: PayloadAction<any>) => {
          state.isDeleteAvailabiltyLoading = false;
          state.isDeleteAvailabiltyError = true;
          state.deleteAvailabiltyMessage = action.payload;
        }
      )
      .addCase(addService.pending, (state) => {
        state.isAddServiceLoading = true;
      })
      .addCase(addService.fulfilled, (state, action) => {
        state.isAddServiceLoading = false;
        state.isSuccess = true;
        state.isAddServiceError = false;
        state.addServiceMessage = "";
        state.addServicePayload = action.payload;
      })
      .addCase(addService.rejected, (state, action: PayloadAction<any>) => {
        state.isAddServiceLoading = false;
        state.isAddServiceError = true;
        state.addServiceMessage = action.payload;
      })
      .addCase(deleteService.pending, (state) => {
        state.isDeleteServiceLoading = true;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.isDeleteServiceLoading = false;
        state.isSuccess = true;
        state.deleteServiceMessage = "";
        state.deleteServicePayload = action.payload;
      })
      .addCase(deleteService.rejected, (state, action: PayloadAction<any>) => {
        state.isDeleteServiceLoading = false;
        state.isDeleteServiceError = true;
        state.deleteServiceMessage = action.payload;
      })
      .addCase(getDoctorFee.pending, (state) => {
        state.isGetDoctorFeeLoading = true;
      })
      .addCase(getDoctorFee.fulfilled, (state, action) => {
        state.isGetDoctorFeeLoading = false;
        state.isSuccess = true;
        state.getDoctorFeeMessage = "";
        state.getDoctorFeePayload = action.payload;
      })
      .addCase(getDoctorFee.rejected, (state, action: PayloadAction<any>) => {
        state.isGetDoctorFeeLoading = false;
        state.isGetDoctorFeeError = true;
        state.getDoctorFeeMessage = action.payload;
      })

      .addCase(registerVerifyOtp.pending, (state) => {
        state.isVerifyOTPLoading = true;
      })
      .addCase(registerVerifyOtp.fulfilled, (state, action) => {
        state.isVerifyOTPLoading = false;
        state.isSuccess = true;
        state.isVerifyOTPError = false;
        state.verifyOTPMessage = "";
        state.verifyOTPPayload = action.payload;
      })
      .addCase(
        registerVerifyOtp.rejected,
        (state, action: PayloadAction<any>) => {
          state.isVerifyOTPLoading = false;
          state.isVerifyOTPError = true;
          state.verifyOTPMessage = action.payload;
        }
      )
      .addCase(getDoctorPermissions.pending, (state) => {
        state.isGetDoctorPermissionsLoading = true;
      })
      .addCase(getDoctorPermissions.fulfilled, (state, action) => {
        state.isGetDoctorPermissionsLoading = false;
        state.isSuccess = true;
        state.isGetDoctorPermissionsError = false;
        state.getDoctorPermissionsMessage = "";
        state.getDoctorPermissionsPayload = action.payload;
      })
      .addCase(
        getDoctorPermissions.rejected,
        (state, action: PayloadAction<any>) => {
          state.isGetDoctorPermissionsLoading = false;
          state.isGetDoctorPermissionsError = true;
          state.getDoctorPermissionsMessage = action.payload;
        }
      )
      .addCase(addDoctorPermissions.pending, (state) => {
        state.isAddDoctorPermissionsLoading = true;
      })
      .addCase(addDoctorPermissions.fulfilled, (state, action) => {
        state.isAddDoctorPermissionsLoading = false;
        state.isSuccess = true;
        state.isAddDoctorPermissionsError = false;
        state.addDoctorPermissionsMessage = "";
        state.addDoctorPermissionsPayload = action.payload;
      })
      .addCase(
        addDoctorPermissions.rejected,
        (state, action: PayloadAction<any>) => {
          state.isAddDoctorPermissionsLoading = false;
          state.isAddDoctorPermissionsError = true;
          state.addDoctorPermissionsMessage = action.payload;
        }
      );
  },
});

export const { reset } = doctorAuthSlice.actions;
export default doctorAuthSlice.reducer;
